/**
 * Check is server side or browser
 * @return {boolean} serverSide
 */
const isServer = () => (typeof window === 'undefined');

export default isServer;
